import React from 'react';

import ContactOption from '../contact-option/contact-option';

import type { ContactOptions as Props } from './contact-options.types';
import { useSalesforceMessaging } from 'root/client/hooks/use-salesforce-messaging';

const ContactOptions: React.FunctionComponent<Props> = ({ chat, entries }) => {
  if (chat) {
    useSalesforceMessaging(chat.esw, chat.init, chat.settings, chat.preChat);
  }

  return (
    <div className="contact-options">
      {entries.map(entry => (
        <ContactOption {...entry} key={entry.key} />
      ))}
    </div>
  );
};

export default ContactOptions;
